'use strict'

import React from 'react';

import Demo from './demo/Demo.jsx';

import Translations from '../app/utils/translations.js';

import performance from '../app/utils/performance.js';

let translations=new Translations([
    require('./portfolio/labels/english.js'),
    require('./portfolio/labels/norwegian.js')
]);

class Login extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div title={labels.general.login} style={{background: "url('/icons/user_Avatar-32x48.png') 5px 5px no-repeat", backgroundSize: "20px 30px", height: 45}}>
      </div>
    );
  }
}

class Profile extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div title={labels.general.profile} style={{background: "url('/icons/user_Avatar-32x48.png') 5px 5px no-repeat", backgroundSize: "20px 30px", height: 40}}>
      </div>
    );
  }
}

class SearchField extends React.Component {

  performSearch(event) {
    event.preventDefault();
  }

  updateCriteria(event) {
    this.setState({search: event.target.value});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div style={{ width: 229, height: 38, background: "#374151", border: "1px solid #374151", boxSizing: "border-box", boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)", borderRadius: "6px"}}>

        <form method="GET" action="/search" style={{display: "flex", justifyContent:"flex-end"}}>
            <SearchIcon/>
            <input className="input" style={{marginTop:2, fontSize:"14px", color: "white", background: "#374151",borderStyle: "none"}}  autoFocus name="criteria" placeholder={labels.general.search} onChange={this.updateCriteria.bind(this)}/>
        </form>
      </div>
    );
  }
}

class Add extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div title={labels.general.addProject} style={{background: "url('/images/Top_Plus.png') center", height: 40}}>
      </div>
    );
  }
}

class Filter extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div title={labels.general.filterProjects} style={{background: "url('/images/Top_Filter.gif') center", height: 40}}>
      </div>
    );
  }
}

class MenuEntry extends React.Component {
  render() {
    return (
      <div style={{width: 30, textAlign:"center", display: "inline-block", fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif", fontSize: "11px"}}>
        <a href={this.props.link} style={{textDecoration: "none", color:"black"}}>
          {this.props.children}
        </a>
      </div>
    );
  }
}

export class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state={showInput:false};
  }

  search(event) {
    event.preventDefault();
    this.setState({showInput:!this.state.showInput});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    return this.state.showInput ? (
      <div style={{width:300, textAlign:"right", height:48}}>
        <SearchField {...this.props}/>
      </div>
    ) : (
      <div id="search" onClick={this.search.bind(this)}>
        <MenuEntry {...this.props} link="#">
          <div title={labels.general.search} style={{background: "url('/images/Top_Search.gif') -8px 2px no-repeat", height: 48}}>
          </div>
        </MenuEntry>
      </div>
    );
  }
}

class Menu extends React.Component {
  render() {
    return (
      <div style={{float: "right", display: "flex", justifyContent:"space-around", paddingTop: this.props.topMargin, marginRight: 30}}>

        <MenuEntry {...this.props} link="/add">
          <Add {...this.props}/>
        </MenuEntry>
        {this.props.user!==undefined ? (
          <MenuEntry {...this.props} link="/filter">
            <Filter {...this.props}/>
          </MenuEntry>
        ): null}
        {this.props.user!==undefined
          ? (
            <MenuEntry {...this.props} link="/profile">
              <Profile {...this.props}/>
            </MenuEntry>
          ) : this.props.tenant!==undefined && this.props.tenant.name ? (
            <MenuEntry {...this.props} link="/setupTenant.html">
              <Profile {...this.props}/>
            </MenuEntry>
          ) : (
            <MenuEntry {...this.props} link="/login">
              <Login {...this.props}/>
            </MenuEntry>
          )
        }
      </div>
    );
  }
}

class HamburgerIcon extends React.Component {
  render() {
    return (
      <span style={{marginLeft:20, marginRight:15}}>
        <svg width="24" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 15H18.25" stroke="#6B7280" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 10H18.25" stroke="#6B7280" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 5H18.25"  stroke="#6B7280" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    );
  }
}

class SearchIcon extends React.Component {
  render() {
    return (
      <span style={{marginLeft:15, marginRight:10, marginTop:10}}>
        <svg className="icon bs-nm  " width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z" fill="#9A9EB1"></path></svg>
      </span>
    );
  }
}

class HomeIcon extends React.Component {
  render() {
    return (
      <span>
      <svg className="icon bs-nm" width="16" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M17.8045 9.52852L10.4712 2.19519C10.3462 2.07021 10.1766 2 9.99986 2C9.82308 2 9.65354 2.07021 9.52852 2.19519L2.19519 9.52852C2.10198 9.62176 2.03851 9.74054 2.0128 9.86984C1.98709 9.99914 2.00029 10.1332 2.05074 10.255C2.10119 10.3768 2.18661 10.4809 2.29622 10.5541C2.40583 10.6274 2.53469 10.6665 2.66652 10.6665H3.49986C3.54406 10.6665 3.58645 10.6841 3.61771 10.7153C3.64897 10.7466 3.66652 10.789 3.66652 10.8332V17.3332C3.66652 17.51 3.73676 17.6796 3.86179 17.8046C3.98681 17.9296 4.15638 17.9999 4.33319 17.9999H8.16652C8.21073 17.9999 8.25312 17.9823 8.28438 17.951C8.31563 17.9198 8.33319 17.8774 8.33319 17.8332V14.6665C8.33319 14.2245 8.50879 13.8006 8.82135 13.488C9.13391 13.1755 9.55783 12.9999 9.99986 12.9999C10.4419 12.9999 10.8658 13.1755 11.1784 13.488C11.4909 13.8006 11.6665 14.2245 11.6665 14.6665V17.8332C11.6665 17.8774 11.6841 17.9198 11.7153 17.951C11.7466 17.9823 11.789 17.9999 11.8332 17.9999H15.6665C15.8433 17.9999 16.0129 17.9296 16.1379 17.8046C16.263 17.6796 16.3332 17.51 16.3332 17.3332V10.8332C16.3332 10.789 16.3507 10.7466 16.382 10.7153C16.4133 10.6841 16.4557 10.6665 16.4999 10.6665H17.3332C17.465 10.6665 17.5939 10.6274 17.7035 10.5541C17.8131 10.4809 17.8985 10.3768 17.949 10.255C17.9994 10.1332 18.0126 9.99914 17.9869 9.86984C17.9612 9.74054 17.8977 9.62176 17.8045 9.52852Z" fill="#9A9EB1"></path></svg>
      </span>
    );
  }
}

class Separator extends React.Component {
  render() {
    return (
      <span style={{marginLeft:16, marginRight:16}}>
        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.9692 5C6.96937 5.1366 6.9404 5.27167 6.88423 5.39619C6.82805 5.52071 6.74597 5.63182 6.64344 5.72209L1.98596 9.81953C1.83162 9.94903 1.63274 10.013 1.43184 9.99779C1.23095 9.98257 1.04398 9.88935 0.910916 9.73807C0.777855 9.58679 0.709263 9.38945 0.719808 9.18825C0.730353 8.98705 0.819197 8.79797 0.967343 8.66142L5.04014 5.07852C5.05132 5.06872 5.06027 5.05664 5.06641 5.0431C5.07255 5.02956 5.07572 5.01487 5.07572 5C5.07572 4.98513 5.07255 4.97044 5.06641 4.9569C5.06027 4.94336 5.05132 4.93128 5.04014 4.92148L0.967343 1.33858C0.819197 1.20203 0.730353 1.01295 0.719808 0.811749C0.709263 0.610551 0.777855 0.413213 0.910916 0.261931C1.04398 0.110648 1.23095 0.0174293 1.43184 0.0022066C1.63274 -0.0130161 1.83162 0.0509657 1.98596 0.180471L6.64177 4.27665C6.74455 4.36709 6.8269 4.47836 6.88335 4.60308C6.93981 4.7278 6.96907 4.8631 6.9692 5Z" fill="#9A9EB1"/>
        </svg>
      </span>
    );
  }
}

class Navigation extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var link=(this.props.projectMenu===undefined) ? "?showMenu=true" : "?";
    var href=(this.props.portfolioSource!==undefined ? this.props.portfolioSource : '')+(this.props.project.isProgramme ? "/programmes/" : this.props.project.isProduct ? "/products/" : this.props.project.isRelease ? "/releases/" : "/projects/")+this.props.project.id;
    return (
      <span>
        {this.props.parent!==undefined ?
          "  /  "
          : null}
        <span><a href={href} style={{color: this.props.layout.color, textDecoration: "none"}}>{this.props.project.releaseName || this.props.project.name}</a></span>
        <span title={labels.general.projectMenu} style={{marginLeft:15}}>
          <a href={link}><HamburgerIcon/></a>
          <div id="projectMenu">{this.props.projectMenu}</div>
        </span>
      </span>
    );
  }
}

class ClientScriptConfig extends React.Component {
  transferState() {
    var clientDataWithLanguageSettings=Object.assign({},this.props.client,{
      language: this.props.language,
      variant: this.props.variant,
      tenant: performance.strippedTenant(this.props.client.tenant, this.props.client.includeStakeholders),
      showMenu: this.props.showMenu,
      project: performance.strippetProject(this.props.client.project)
    });
    if (this.props.environment!==undefined && this.props.environment.demo!==undefined) {
      clientDataWithLanguageSettings.environment={demo:this.props.environment.demo};
    }
    return {__html: "window.APP_DATA="+JSON.stringify(clientDataWithLanguageSettings)};
  }
  render() {
    return (this.props.client!==undefined) ? (
      <script lang="javascript" dangerouslySetInnerHTML={this.transferState()}>
      </script>
    ) : (
      null
    )
  }
}

class PortfolioNavigation extends React.Component {

  getPortfolioUrl(source,portfolio) {
    return (source!==undefined ? source+"/portfolios/" : "/portfolio/") + (
      portfolio.id!=="other"
        ? portfolio.id
        : source!==undefined
          ? "_other"
          : portfolio.id
      );
  }

  render() {
    let labels=translations.getTranslation(this.props);
    var portfolio=this.props.portfolio!==undefined ? this.props.portfolio :
      this.props.project!==undefined && this.props.project.portfolio!==undefined && this.props.tenant.portfolios!==undefined ?
        this.props.tenant.portfolios.filter(portfolio=>portfolio.id===this.props.project.portfolio)[0] : undefined;
    if (this.props.project!==undefined && portfolio===undefined && this.props.tenant!==undefined && this.props.tenant.portfolios!==undefined && this.props.tenant.portfolios.length>0) {
      portfolio={id:"other", name: labels.general.otherPortfolio};
    }
    if (portfolio!==undefined && portfolio.other) {
      portfolio.name=labels.general.otherPortfolio;
      portfolio.id="other";
    }
    return portfolio!==undefined ? (
      <span>
        {portfolio.name!==undefined ? (
          <a style={{color:this.props.layout.color,textDecoration:"none", fontfamily:"Lato", fontstyle:"normal", fontweight:"normal", fontsize:"14px", lineheight:"20px"}} href={this.getPortfolioUrl(this.props.portfolioSource,portfolio)}> <Separator/>{portfolio.name}</a>
        ) : portfolio}{portfolio.id==="other" && this.props.project!==undefined ? "  /  " : null}
      </span>
    ) : null;
  }
}

class ClientScript extends React.Component {
  render() {
    return (this.props.client!==undefined) ? (
      <script src="/client/bundle.js"></script>
    ) : (
      null
    )
  }
}

class EnvironmentDetails extends React.Component {
  render() {
    return this.props.environment!==undefined ? (
      <div style={{position:"relative"}}>
        {this.props.environment.name!=="production" ? (
          <div style={{position:"fixed", top:0, bottom:0,left:0,right:0,display:"flex",justifyContent:"center", alignItems:"center",pointerEvents:"none",zIndex:9999}}>
            <div style={{color:"rgba(255,0,0,0.15)",fontSize:"8em",transform:"rotate(-45deg)"}}>
              {this.props.environment.name!==undefined ? this.props.environment.name : "local"}
            </div>
          </div>
        ):null}
        {this.props.environment.disabledPersistence ? (
          <div id="demo"><Demo {...this.props}/></div>
        ) : null }
      </div>
    ) : null;
  }
}

export default class Layout extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var defaultLayout={
      logo: "/progreto_logo.png",
      color: "#595959",
      height:46,
      width: 149,
      size: 119,
      position:30,
      backgroundColor: "#1F2937",
      showTenantName: true,
    }
    var layout=this.props.tenant!==undefined && this.props.tenant.design!==undefined && this.props.tenant.design.enabled ? this.props.tenant.design : defaultLayout;

    var foundTenant=this.props.project!==undefined && this.props.tenant!==undefined && this.props.tenant.portfolios!=undefined && this.props.tenant.portfolios.length>0 ? this.props.tenant.portfolios.filter(portfolio=>portfolio.id===this.props.project.portfolio)[0] : undefined;
    var portfolio=this.props.project!==undefined && this.props.project.portfolio!==undefined && this.props.tenant.portfolios!==undefined
            ? foundTenant!==undefined
              ? foundTenant
              : {id:"other", name:labels.general.otherPortfolio}
            : undefined;

    var project=(this.props.project!==undefined)
      ? <Navigation {...this.props} layout={layout} parent={portfolio} project={this.props.project} projectMenu={this.props.projectMenu}/>
    : "";
    var tenantName=(this.props.tenant!==undefined && this.props.tenant.name!==undefined)
      ? this.props.tenant.name :
      <span>&lt;{labels.general.unknownTenantName}&gt;</span>;

    let htmlLanguage=()=>{
      switch (this.props.language) {
        case "norwegian":
          return "nb";
        default:
          return "en";
      }
    };

    return (
      <html lang={htmlLanguage()}>
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="description" content="Progreto - implementing your strategic plan"/>
          <link rel="stylesheet" href="/progreto.css"/>
          <link href="https://fonts.googleapis.com/css?family=Lato&display=swap" rel="stylesheet"/>
          <title>{layout.title!==undefined ? layout.title : "Progreto - implementing your strategic plan"}</title>
          <ClientScriptConfig {...this.props} client={this.props.client!==undefined ? this.props.client : "true"}/>
        </head>
        <body style={{marginTop: 0, marginLeft:0, marginRight: 0}}>
          <EnvironmentDetails {...this.props}/>
          <div style={{width:"100%"}}>
            <div style={{display: "inline-block", color:layout.color, position: "relative", width: "100%", borderBottom: "2px solid #f5f5f5"}}>
              <div style={{width: "100%", margin: "0 auto !important", backgroundColor: layout.backgroundColor}}>
                <div style={{maxWidth: 1400, float:"none", width: "100%", margin: "0 auto !important", backgroundColor: layout.backgroundColor, height: layout.height+18, marginBottom:20}}>
                  <a style={{position: "absolute", paddingTop:3, height: layout.height, width: layout.width, backgroundImage: layout.background!==undefined ? "url('"+layout.background+"')" : undefined, backgroundSize:"auto", backgroundRepeat: "no-repeat", backgroundColor: layout.backgroundColor}} href={this.props.portfolioSource!==undefined ? this.props.portfolioSource : "/"}>
                  <div style={{display: "inline-block", width: layout.width, height:layout.height, paddingTop: 10, backgroundImage: "url('"+layout.logo+"')", backgroundPosition: layout.position, backgroundSize:layout.size!==undefined ? layout.size : "contain", backgroundRepeat: "no-repeat"}}></div></a>
                  {this.props.user!==undefined ? (
                    <div style={{ paddingLeft:layout.width+50, paddingTop:13}}><SearchField {...this.props}/></div>
                  ) : null}
                </div>
              </div>
              <div style={{maxWidth: 1400, float:"none",  margin: "0 auto !important", paddingTop:10, marginBottom:10}}>
                <div style={{marginLeft: 30, marginTop:5, display: "inline-block", fontFamily: "Lato, Georgia, Times, 'Times New Roman', serif", color: layout.color, fontSize: "14px"}}>
                  <a href={this.props.portfolioSource!==undefined ? this.props.portfolioSource : "/"}><HomeIcon/></a>
                  <PortfolioNavigation {...this.props} layout={layout}/>{project}
                </div>
                <Menu {...this.props} topMargin={0}/>
              </div>
            </div>
          </div>
          {layout.showTenantName ? (
              <div style={{maxWidth: 1400, float:"none", margin: "0 auto !important"}}>
                <div style={{paddingLeft:30, paddingTop: 10, fontFamily:"Lato", fontSize:"120%"}}>
                  <span>
                    <a href="/setupTenant.html" style={{color: layout.color, textDecoration: "none"}}>
                      {tenantName}
                    </a>
                  </span>
                </div>
              </div>
            ) : null}
          <div style={{maxWidth: 1400, float:"none", margin: "0 auto !important"}} id={this.props.view}>
            {this.props.children}
          </div>
          <ClientScript {...this.props} client={this.props.client!==undefined ? this.props.client : "true"}/>
        </body>
      </html>
    );
  }
}



// WEBPACK FOOTER //
// ./views/Layout.jsx